import { Outlet, Link, useNavigate } from "react-router-dom";
import { IoStatsChart, IoPeople, IoTime, IoMegaphone, IoLogOut } from "react-icons/io5";
import { GoHistory } from "react-icons/go";
import "../../design/MainLayout.css";

export default function Main() {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('AdminToken');
        navigate('/login');
    };

    return (
        <div className="admin-layout">
            {/* LEFT SIDEBAR */}
            <aside className="admin-sidebar">
                <div className="sidebar-header">
                    <h2>TEACHER<span>HUB</span></h2>
                </div>

                <nav className="sidebar-nav">
                    <Link to="/requests" className="nav-item">
                        <IoTime /> Pending Requests
                    </Link>
                    <Link to="/users" className="nav-item">
                        <IoPeople /> All Teachers
                    </Link>
                    <Link to="/payments-history" className="nav-item">
                        <GoHistory /> Payments History
                    </Link>
                    <Link to="/ads" className="nav-item">
                        <IoMegaphone /> Ads Manager
                    </Link>
                    <Link to="/analytics" className="nav-item">
                        <IoStatsChart /> Analytics
                    </Link>
                </nav>

                <div className="sidebar-footer">
                    <button onClick={handleLogout} className="logout-btn">
                        <IoLogOut /> Logout
                    </button>
                </div>
            </aside>

            {/* RIGHT CONTENT AREA */}
            <main className="admin-content">
                <header className="content-header">
                    <h1>Admin Dashboard</h1>
                </header>
                <div className="content-body">
                    <Outlet /> {/* This is where child components load */}
                </div>
            </main>
        </div>
    );
}